import logo from '../imagenes/284155446_5051543411565338_4169603858621060659_n.jpg'
import foto from '../imagenes/IMG_20250306_143204.jpg'
import foto2 from '../imagenes/IMG_20250325_143645.jpg'
import foto3 from '../imagenes/IMG_20250327_154747.jpg'

export const carrusel = [
    { src: logo, link: 'logo' },
    { src: foto, link: 'foto' },
    { src: foto2, link: 'foto2' },
    { src: foto3, link: 'foto3' }
]